"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
require('./styles.scss');
var ListColumnsToggle_1 = require("./ListColumnsToggle");
var QuickFilters_1 = require("./QuickFilters");
var enhance = (0, recompose_1.compose)((0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.isMobile !== nextProps.isMobile ||
            this.props.dropdownOptions !== nextProps.dropdownOptions ||
            this.props.sortDropdownToggled !== nextProps.sortDropdownToggled ||
            this.props.filtersDropdownToggled !==
                nextProps.filtersDropdownToggled ||
            this.props.columnsDropdownToggled !==
                nextProps.columnsDropdownToggled ||
            this.props.currentProject !== nextProps.currentProject ||
            this.props.filteredMetadata !== nextProps.filteredMetadata ||
            this.props.sortByOptions !== nextProps.sortByOptions ||
            this.props.searchOptions.toggleHideEmptyFolders !==
                nextProps.searchOptions.toggleHideEmptyFolders ||
            this.props.currentFolder !== nextProps.currentFolder ||
            this.props.filtering !== nextProps.filtering ||
            this.props.metadata !== nextProps.metadata) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var FileListFilter = enhance(function (props) {
    return (React.createElement("div", { className: 'filter-block sorts' },
        React.createElement(sok_ui_1.Grid.Row, null,
            React.createElement(sok_ui_1.Grid.Column, { className: 'filter-row' },
                !props.hideColumnFilters && (React.createElement(React.Fragment, null,
                    React.createElement(ListColumnsToggle_1.default, { renderIf: function () {
                            return Boolean(props.currentProject && !props.currentBid && !props.isMobile);
                        }, currentProject: props.currentProject, metadata: props.metadata, filteredMetadata: props.filteredMetadata, selectCustomMeta: props.selectCustomMeta, toggleColumnsDropdown: props.toggleColumnsDropdown, toggleAllMetadataColumns: props.toggleAllMetadataColumns }),
                    React.createElement(QuickFilters_1.default, { renderIf: function () { return true; }, searchOptions: props.searchOptions, filtering: props.filtering, toggleFilter: props.toggleFilter, toggleFiltersDropdown: props.toggleFiltersDropdown, toggleEmptyFolders: props.toggleEmptyFolders }))),
                React.createElement("div", { className: 'filter-list-dropdown' },
                    React.createElement(sok_ui_1.Button, { color: 'blue', className: 'clear-filter-button', text: (0, translation_1.getLocalization)('userfront/project/files/buttons/filter/clearAllFilters'), disabled: false, onClick: function () {
                            props.clearAllFilters();
                        } }))))));
});
exports.default = FileListFilter;
